var _desc, _path, _path2, _path3, _circle, _circle2, _path4, _path5, _path6, _circle3, _circle4, _path7, _circle5, _circle6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    "aria-labelledby": titleId,
    "aria-describedby": "desc",
    role: "img",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Truck") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "A color styled icon from Orion Icon Library.")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "layer4",
    d: "M59.2 31h-3.9l-4.4-8H39v8h20.2z",
    fill: "#c3d6e0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "layer2",
    d: "M61 32.4c0-1.1-.9-1.3-1.7-1.4H39v12h5.5a6 6 0 0 1 8.9 0H61z",
    fill: "#7b8baf"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "layer3",
    d: "M39 15H3v28h5.5a6 6 0 0 1 8.9 0H39V15z",
    fill: "#f27e7c"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-name": "layer2",
    cx: 13,
    cy: 47,
    r: 6,
    fill: "#7b8baf"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    "data-name": "layer2",
    cx: 49,
    cy: 47,
    r: 6,
    fill: "#7b8baf"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-name": "layer1",
    d: "M44.5 43h-27a6 6 0 0 1 1.2 6h24.6a6 6 0 0 1 1.2-6zm9 0a6 6 0 0 1 1.2 6H61v-6z",
    fill: "#8fa9d8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    "data-name": "opacity",
    fill: "#fff",
    opacity: 0.5,
    d: "M51.8 24.6l-.9-1.6h-3.3l-8 8h5.7l6.5-6.4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    "data-name": "opacity",
    d: "M8 15H3v28h5.5a6 6 0 0 1 8.9 0H39v-4H8zm10.6 34h24.7a5.7 5.7 0 0 1-.3-3H18.9a5.7 5.7 0 0 1-.3 3zm36 0H61v-3h-6.1a5.7 5.7 0 0 1-.3 3z",
    fill: "#000064",
    opacity: 0.15
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    "data-name": "opacity",
    cx: 13,
    cy: 47,
    r: 3,
    fill: "#000064",
    opacity: 0.2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    "data-name": "opacity",
    cx: 49,
    cy: 47,
    r: 3,
    fill: "#000064",
    opacity: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    "data-name": "stroke",
    fill: "none",
    stroke: "#212630",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M43.3 49H18.7M61 49h-6.3m-10.2-6H39m0-20h11.9l4.4 8h3.9c.8 0 1.8.2 1.8 1.4V43h-7.5m1.8-12H39M8.5 43H3V15h36v28H17.5"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    "data-name": "stroke",
    cx: 13,
    cy: 47,
    r: 6,
    fill: "none",
    stroke: "#212630",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    "data-name": "stroke",
    cx: 49,
    cy: 47,
    r: 6,
    fill: "none",
    stroke: "#212630",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.8a9ef4dd91cb3cdbbe59ed9583089197.svg";
export { ForwardRef as ReactComponent };